import { Component } from 'react';
import languages from '../languages.js';

class Settings extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openaiApiKey: '',
			oldOpenaiApiKey: '',
		};

		this.handleInput = this.handleInput.bind(this);

		this.limits = {
			maxSentencesPerParagraph: {
				min: 1,
				max: 10,
			},
			maxWordsPerParagraph: {
				min: 1,
				max: 200,
			},
			maxParagraphsPerHeading: {
				min: 1,
				max: 10,
			},
			maxWordsInIntro: {
				min: 1,
				max: 100,
			},
			maxWordsPerSentence: {
				min: 1,
				max: 30,
			},
		};

		this.locations = [
			"Algeria",
			"Angola",
			"Argentina",
			"Armenia",
			"Australia",
			"Austria",
			"Azerbaijan",
			"Bahrain",
			"Bangladesh",
			"Belgium",
			"Bolivia",
			"Brazil",
			"Bulgaria",
			"Burkina Faso",
			"Cambodia",
			"Cameroon",
			"Canada",
			"Chile",
			"Colombia",
			"Costa Rica",
			"Cote d'Ivoire",
			"Croatia",
			"Cyprus",
			"Czechia",
			"Denmark",
			"Ecuador",
			"Egypt",
			"El Salvador",
			"Estonia",
			"Finland",
			"France",
			"Germany",
			"Ghana",
			"Greece",
			"Guatemala",
			"Hungary",
			"India",
			"Indonesia",
			"Ireland",
			"Israel",
			"Italy",
			"Japan",
			"Jordan",
			"Kazakhstan",
			"Kenya",
			"Latvia",
			"Lithuania",
			"Malaysia",
			"Malta",
			"Mexico",
			"Morocco",
			"Myanmar",
			"Netherlands",
			"New Zealand",
			"Nicaragua",
			"Nigeria",
			"North Macedonia",
			"Norway",
			"Pakistan",
			"Panama",
			"Paraguay",
			"Peru",
			"Philippines",
			"Poland",
			"Portugal",
			"Romania",
			"Saudi Arabia",
			"Senegal",
			"Serbia",
			"Singapore",
			"Slovakia",
			"Slovenia",
			"South Africa",
			"South Korea",
			"Spain",
			"Sri Lanka",
			"Sweden",
			"Switzerland",
			"Thailand",
			"Tunisia",
			"Turkiye",
			"Ukraine",
			"United Arab Emirates",
			"United Kingdom",
			"United States",
			"Uruguay",
			"Venezuela",
			"Vietnam",
		];
		this.locationNames = [
			window?.t?.COUNTRY_ALGERIA,
			window?.t?.COUNTRY_ANGOLA,
			window?.t?.COUNTRY_ARGENTINA,
			window?.t?.COUNTRY_ARMENIA,
			window?.t?.COUNTRY_AUSTRALIA,
			window?.t?.COUNTRY_AUSTRIA,
			window?.t?.COUNTRY_AZERBAIJAN,
			window?.t?.COUNTRY_BAHRAIN,
			window?.t?.COUNTRY_BANGLADESH,
			window?.t?.COUNTRY_BELGIUM,
			window?.t?.COUNTRY_BOLIVIA,
			window?.t?.COUNTRY_BRAZIL,
			window?.t?.COUNTRY_BULGARIA,
			window?.t?.COUNTRY_BURKINAFASO,
			window?.t?.COUNTRY_CAMBODIA,
			window?.t?.COUNTRY_CAMEROON,
			window?.t?.COUNTRY_CANADA,
			window?.t?.COUNTRY_CHILE,
			window?.t?.COUNTRY_COLOMBIA,
			window?.t?.COUNTRY_COSTARICA,
			window?.t?.COUNTRY_COTEDIVOIRE,
			window?.t?.COUNTRY_CROATIA,
			window?.t?.COUNTRY_CYPRUS,
			window?.t?.COUNTRY_CZECHIA,
			window?.t?.COUNTRY_DENMARK,
			window?.t?.COUNTRY_ECUADOR,
			window?.t?.COUNTRY_EGYPT,
			window?.t?.COUNTRY_ELSALVADOR,
			window?.t?.COUNTRY_ESTONIA,
			window?.t?.COUNTRY_FINLAND,
			window?.t?.COUNTRY_FRANCE,
			window?.t?.COUNTRY_GERMANY,
			window?.t?.COUNTRY_GHANA,
			window?.t?.COUNTRY_GREECE,
			window?.t?.COUNTRY_GUATEMALA,
			window?.t?.COUNTRY_HUNGARY,
			window?.t?.COUNTRY_INDIA,
			window?.t?.COUNTRY_INDONESIA,
			window?.t?.COUNTRY_IRELAND,
			window?.t?.COUNTRY_ISRAEL,
			window?.t?.COUNTRY_ITALY,
			window?.t?.COUNTRY_JAPAN,
			window?.t?.COUNTRY_JORDAN,
			window?.t?.COUNTRY_KAZAKHSTAN,
			window?.t?.COUNTRY_KENYA,
			window?.t?.COUNTRY_LATVIA,
			window?.t?.COUNTRY_LITHUANIA,
			window?.t?.COUNTRY_MALAYSIA,
			window?.t?.COUNTRY_MALTA,
			window?.t?.COUNTRY_MEXICO,
			window?.t?.COUNTRY_MOROCCO,
			window?.t?.COUNTRY_MYANMAR,
			window?.t?.COUNTRY_NETHERLANDS,
			window?.t?.COUNTRY_NEWZEALAND,
			window?.t?.COUNTRY_NICARAGUA,
			window?.t?.COUNTRY_NIGERIA,
			window?.t?.COUNTRY_NORTHMACEDONIA,
			window?.t?.COUNTRY_NORWAY,
			window?.t?.COUNTRY_PAKISTAN,
			window?.t?.COUNTRY_PANAMA,
			window?.t?.COUNTRY_PARAGUAY,
			window?.t?.COUNTRY_PERU,
			window?.t?.COUNTRY_PHILIPPINES,
			window?.t?.COUNTRY_POLAND,
			window?.t?.COUNTRY_PORTUGAL,
			window?.t?.COUNTRY_ROMANIA,
			window?.t?.COUNTRY_SAUDIARABIA,
			window?.t?.COUNTRY_SENEGAL,
			window?.t?.COUNTRY_SERBIA,
			window?.t?.COUNTRY_SINGAPORE,
			window?.t?.COUNTRY_SLOVAKIA,
			window?.t?.COUNTRY_SLOVENIA,
			window?.t?.COUNTRY_SOUTHAFRICA,
			window?.t?.COUNTRY_SOUTHKOREA,
			window?.t?.COUNTRY_SPAIN,
			window?.t?.COUNTRY_SRILANKA,
			window?.t?.COUNTRY_SWEDEN,
			window?.t?.COUNTRY_SWITZERLAND,
			window?.t?.COUNTRY_THAILAND,
			window?.t?.COUNTRY_TUNISIA,
			window?.t?.COUNTRY_TURKIYE,
			window?.t?.COUNTRY_UKRAINE,
			window?.t?.COUNTRY_UNITEDARABEMIRATES,
			window?.t?.COUNTRY_UNITEDKINGDOM,
			window?.t?.COUNTRY_UNITEDSTATES,
			window?.t?.COUNTRY_URUGUAY,
			window?.t?.COUNTRY_VENEZUELA,
			window?.t?.COUNTRY_VIETNAM,
		];
	}

	handleInput(event) {
		if (event.target.dataset.option === 'openaiApiKey') {
			this.setState({
				openaiApiKey: event.target.value,
			});
			return;
		}
		let settingName = event.target.dataset.option;
		let settingValue = event.target.value;
		if (settingName in this.limits) {
			const limit = this.limits[settingName];
			if (limit.min && !isNaN(settingValue) && parseInt(settingValue) < limit.min) {
				settingValue = limit.min;
			}
			if (limit.max && !isNaN(settingValue) && parseInt(settingValue) > limit.max) {
				settingValue = limit.max;
			}
		}
		this.props.changeCallback(settingName, settingValue);
	}

	getOpenaiApiKey() {
		return new Promise((resolve) => {
			const formData = new FormData();
			formData.append('action', 'get');

			fetch(`https://${window.location.hostname}/tools/content/ajax/openai-key.php`, {
				method: 'POST',
				body: formData,
			})
			.then((response) => {
				if (response.status < 400) {
					return response.json();
				}
				resolve('');
			})
			.then((data) => {
				if (data.status === 'ok') {
					resolve(data.openaiApiKey);
				} else {
					resolve('');
				}
			})
			.catch((error) => {
				console.error(error);
				resolve('');
			});
		})
	}

	async componentDidMount() {
		const openaiApiKey = await this.getOpenaiApiKey();
		this.setState({
			openaiApiKey: openaiApiKey,
			oldOpenaiApiKey: openaiApiKey,
		});
	}

	componentWillUnmount() {
		if (this.state.openaiApiKey === this.state.oldOpenaiApiKey) {
			return;
		}
		const formData = new FormData();
		formData.append('action', 'set');
		formData.append('key', this.state.openaiApiKey);

		fetch(`https://${window.location.hostname}/tools/content/ajax/openai-key.php`, {
			method: 'POST',
			body: formData,
		})
		.catch((error) => {
			console.error(error);
		});
	}

	prepareLangOptions() {
		const languageOptions = languages.map((lang) => {
			let key = 'language-' + lang.id;
			return (
				<option key={key} value={lang.langCode}>{window?.t[`LANG_${lang.t}`]} ({lang.langCode})</option>
			)
		});
		return languageOptions;
	}

	prepareLocationOptions() {
		const countries = [...new Set(this.locations)];
		const countryOptions = countries.map((country, index) => {
			let key = 'country-' + index;
			return (
				<option key={key} value={country}>{this.locationNames[index]}</option>
			)
		});
		return [(<option key="country" value="">{window?.t?.LBL_LOCATION}</option>), ...countryOptions];
	}

	render() {
		const {permissions} = this.props;
		const openAiApiKeyInput = permissions.includes('content-own-api-key')
			? (<p className="form-field">
				<label htmlFor="openai-api-key">{window?.t?.LBL_OPENAI_KEY}</label>
				<input id="openai-api-key" data-option="openaiApiKey" type="password" defaultValue={this.state.openaiApiKey} onInput={this.handleInput} autocomplete="new-password" />
			</p>)
			: '';
		return (
			<div className="settings">
				<button className="button-close" onClick={this.props.closeCallback}>&times;</button>
				<h2>{window?.t?.SETTINGS}</h2>
				<p className="form-field">
					<label htmlFor="language">{window?.t?.LBL_LANGUAGE}</label>
					<select name="language" id="language" data-option="language" value={this.props.settings.language} onChange={this.handleInput}>{this.prepareLangOptions()}</select>
				</p>
				<p className="form-field">
					<label htmlFor="location">{window?.t?.LBL_COUNTRY_FOR_GOOGLE}</label>
					<select name="location" id="location" data-option="location" value={this.props.settings.location} onChange={this.handleInput}>{this.prepareLocationOptions()}</select>
				</p>
				<p className="form-field">
					<label htmlFor="language">{window?.t?.LBL_RELATED_KEYWORDS_BASED_ON}</label>
					<select name="language" id="language" data-option="keywordSrc" value={this.props.settings.keywordSrc} onChange={this.handleInput}>
						{permissions.includes('content-related-keywords-ai') ? (<option value="entities">{window?.t?.RELATED_KEYWORDS_SRC_ENTITIES}</option>) : ''}
						{permissions.includes('content-related-keywords-ai') ? (<option value="ai">{window?.t?.RELATED_KEYWORDS_SRC_AI}</option>) : ''}
						<option value="tfidf">{window?.t?.RELATED_KEYWORDS_SRC_TFIDF}</option>
					</select>
				</p>
				{openAiApiKeyInput}

				<p className="form-field">
					<label htmlFor="language">{window?.t?.LBL_AI_LANGUAGE_MODEL}</label>
					<select name="ai-model" id="ai-model" data-option="aiModel" value={this.props.settings.aiModel} onChange={this.handleInput}>
						{permissions.includes('content-o1-allowed') ? (<option value="o1-preview">o1-preview</option>) : ''}
						<option value="gpt-4.1">GPT-4.1</option>
						<option value="gpt-4.1-mini">GPT-4.1 mini</option>
						<option value="gpt-5">GPT-5</option>
						<option value="gpt-5-mini">GPT-5 mini</option>
					</select>
				</p>
				<p className="form-field">
					<label htmlFor="language">{window?.t?.LBL_OUTLINE_AI_LANGUAGE_MODEL}</label>
					<select name="outline-ai-model" id="outline-ai-model" data-option="outlineAiModel" value={this.props.settings.outlineAiModel} onChange={this.handleInput}>
						<option value="gpt-4.1">GPT-4.1</option>
						<option value="gpt-4.1-mini">GPT-4.1 mini</option>
						<option value="gpt-5">GPT-5</option>
						<option value="gpt-5-mini">GPT-5 mini</option>
						{permissions.includes('content-outline-reasoning-ai-models') ? (
							<>
							<option value="o1">o1</option>
							<option value="o1-mini">o1 mini</option>
							<option value="o3">o3</option>
							<option value="o3-mini">o3 mini</option>
							<option value="o4">o4</option>
							<option value="o4-mini">o4 mini</option>
							</>
						) : ''}
					</select>
				</p>
				<p className="form-field">
					<label htmlFor="max-words-per-sentence">{window?.t?.LBL_MAX_WORDS_PER_SENTENCE}</label>
					<input
						type="number"
						min={this.limits.maxWordsPerSentence.min}
						max={this.limits.maxWordsPerSentence.max}
						id="max-words-per-sentence"
						data-option="maxWordsPerSentence"
						defaultValue={this.props.settings.maxWordsPerSentence}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field">
					<label htmlFor="max-sentences-per-paragraph">{window?.t?.LBL_MAX_SENTENCES_PER_P}</label>
					<input
						type="number"
						min={this.limits.maxSentencesPerParagraph.min}
						max={this.limits.maxSentencesPerParagraph.max}
						id="max-sentences-per-paragraph"
						data-option="maxSentencesPerParagraph"
						defaultValue={this.props.settings.maxSentencesPerParagraph}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field">
					<label htmlFor="max-words-per-paragraph">{window?.t?.LBL_MAX_WORDS_PER_P}</label>
					<input
						type="number"
						min={this.limits.maxWordsPerParagraph.min}
						max={this.limits.maxWordsPerParagraph.max}
						id="max-words-per-paragraph"
						data-option="maxWordsPerParagraph"
						defaultValue={this.props.settings.maxWordsPerParagraph}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field">
					<label htmlFor="max-paragraphs-per-heading">{window?.t?.LBL_MAX_P_PER_SECTION}</label>
					<input
						type="number"
						min={this.limits.maxParagraphsPerHeading.min}
						max={this.limits.maxParagraphsPerHeading.max}
						id="max-paragraphs-per-heading"
						data-option="maxParagraphsPerHeading"
						defaultValue={this.props.settings.maxParagraphsPerHeading}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field">
					<label htmlFor="max-words-in-intro">{window?.t?.LBL_MAX_WORDS_INTRO}</label>
					<input
						type="number"
						min={this.limits.maxWordsInIntro.min}
						max={this.limits.maxWordsInIntro.max}
						id="max-words-in-intro"
						data-option="maxWordsInIntro"
						defaultValue={this.props.settings.maxWordsInIntro}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field min-max">
					<label htmlFor="min-keyword-density">{window?.t?.LBL_OPTIMAL_KEYWORD_DENSITY}</label>
					{window?.t?.FROM}: <input type="text" id="min-keyword-density" data-option="minKeywordDensity" defaultValue={this.props.settings.minKeywordDensity} onInput={this.handleInput} />
					{window?.t?.TO}: <input type="text" id="max-keyword-density" data-option="maxKeywordDensity" defaultValue={this.props.settings.maxKeywordDensity} onInput={this.handleInput} />
				</p>
				<p className="form-field min-max">
					<label htmlFor="min-content-length">{window?.t?.LBL_OPTIMAL_CONTENT_LENGTH}</label>
					{window?.t?.FROM}: <input type="text" id="min-content-length" data-option="minContentLength" defaultValue={this.props.settings.minContentLength} onInput={this.handleInput} />
					{window?.t?.TO}: <input type="text" id="max-content-length" data-option="maxContentLength" defaultValue={this.props.settings.maxContentLength} onInput={this.handleInput} />
				</p>
				<p className="form-field">
					<label htmlFor="disallowed-words">{window?.t?.LBL_DISALLOWED_WORDS}</label>
					<textarea id="disallowed-words" rows="10" data-option="disallowedWords" defaultValue={this.props.settings.disallowedWords} onInput={this.handleInput}></textarea>
				</p>
				<p className="form-submit"><button className="button primary" onClick={this.props.closeCallback}>{window?.t?.OK}</button></p>
			</div>
		)
	}
}

export default Settings;